import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

import {prepareAuthHeaders} from '../../utils/prepareAuthHeaders';

export const assistantApi = createApi({
    reducerPath: 'assistantApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/Assistant',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        getAssistantStatus: builder.query({
            query: () => ({
                url: '/Status',
                method: 'GET',
            }),
        }),
        sendAssistantMessage: builder.mutation({
            query: (body) => ({
                url: '/Chat',
                method: 'POST',
                body,
            }),
        }),
        getAssistantHistory: builder.query({
            query: ({page, pageSize}) => ({
                url: '/History',
                method: 'GET',
                params: {page, pageSize},
            }),
        }),
    }),
});

export const {
    useGetAssistantStatusQuery,
    useSendAssistantMessageMutation,
    useGetAssistantHistoryQuery,
} = assistantApi;
